// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalBiDiagnosisCodeRequest {
    'code': string;
    'unit'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalBiDiagnosisCodeRequest>> = [
        {
            "name":     "code",
            "baseName": "code",
            "type":     "string"
        },
        {
            "name":     "unit",
            "baseName": "unit",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalBiDiagnosisCodeRequest.attributeTypeMap;
    }
}
